import { useMutation } from "@tanstack/react-query";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import {
	apiPost,
	getApiUrl,
	type PostChatAddImageFetchResponse,
	postChatAddImagePath,
} from "web_myplann/Infrastructure/ApiOld/Api";

type SendImageVariables = {
	conversationId: number;
	file: File;
	content?: string;
};

export const useSendImageMutation = () =>
	useMutation({
		mutationFn: processResponse(
			({ conversationId, file, content }: SendImageVariables) => {
				const formData = new FormData();
				formData.append("conversationId", String(conversationId));
				formData.append("content", content ?? "");
				formData.append("attachment", file);
				formData.append("attachmentTitle", file.name);

				return apiPost(
					`${getApiUrl()}${postChatAddImagePath()}`,
					formData,
					undefined,
				) as Promise<PostChatAddImageFetchResponse>;
			},
		),
	});
